import styled from '@emotion/styled';

export const Checkbox = styled.input`
  appearance: none;
  margin: 0;

  background-color: ${({ theme }) => theme.checkbox.background};
  box-shadow: ${({ theme }) => theme.checkbox.boxShadow};
  display: flex;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  overflow: hidden;
  position: relative;
  transition: all .2s ease-in-out;
  white-space: nowrap;
  border-radius: 2px;

  &::before {
    content: url("data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="transparent" viewBox="-3 -4 16 16"><path d="M1.49 3.215a.667.667 0 0 0-.98.903l2.408 2.613c.358.351.892.351 1.223.02l.243-.239a1689.645 1689.645 0 0 0 2.625-2.589l.027-.026a328.23 328.23 0 0 0 2.439-2.429.667.667 0 1 0-.95-.936c-.469.476-1.314 1.316-2.426 2.417l-.027.026a1368.126 1368.126 0 0 1-2.517 2.482L1.49 3.215Z"/></svg>");
    width: 16px;
    height: 16px;
    transition: all .2s ease-in-out;
    white-space: nowrap;
  }

  &:hover:not(:disabled,:checked)::before {
    background-color: #ebecf0;
    box-shadow: inset 0 0 0 2px #dfe1e6;
  }


  &:checked::before {
    background-color: #0079bf;
    box-shadow: inset 0 0 0 2px #0079bf;
    content: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23fff' viewBox='-3 -4 16 16'%3E%3Cpath d='M1.49 3.215a.667.667 0 0 0-.98.903l2.408 2.613c.358.351.892.351 1.223.02l.243-.239a1689.645 1689.645 0 0 0 2.625-2.589l.027-.026a328.23 328.23 0 0 0 2.439-2.429.667.667 0 1 0-.95-.936c-.469.476-1.314 1.316-2.426 2.417l-.027.026a1368.126 1368.126 0 0 1-2.517 2.482L1.49 3.215Z'/%3E%3C/svg%3E");
  }

  &:disabled {
    box-shadow: none;
    background-color: ${({ theme }) => theme.checkbox.disabled};

    &::before {
      cursor: not-allowed;
    }
  }

  &[disabled][checked]::before {
    content: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23fff' viewBox='-3 -4 16 16'%3E%3Cpath d='M1.49 3.215a.667.667 0 0 0-.98.903l2.408 2.613c.358.351.892.351 1.223.02l.243-.239a1689.645 1689.645 0 0 0 2.625-2.589l.027-.026a328.23 328.23 0 0 0 2.439-2.429.667.667 0 1 0-.95-.936c-.469.476-1.314 1.316-2.426 2.417l-.027.026a1368.126 1368.126 0 0 1-2.517 2.482L1.49 3.215Z'/%3E%3C/svg%3E");
  }

  &:indeterminate:not(:disabled,:checked)::before {
    background-color: #0079bf;
    box-shadow: inset 0 0 0 2px #0079bf;
    content: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNnB4IiBoZWlnaHQ9IjE2cHgiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZm9jdXNhYmxlPSJmYWxzZSIgcm9sZT0icHJlc2VudGF0aW9uIj48ZyBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxyZWN0IGZpbGw9IiNmZmZmZmYiIHg9IjQiIHk9IjciIHdpZHRoPSI4IiBoZWlnaHQ9IjIiIHJ4PSIxIj48L3JlY3Q+PC9nPjwvc3ZnPg==");
  }
`;

export const CheckboxItem = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const CheckboxLabel = styled.div`
  display: flex;
  margin-left: 4px;
  color: ${({ theme }) => theme.colors.primary};
`;
